import { createAction } from "typesafe-actions";

export const clearError = createAction("CLEAR_ERROR")();
